import * as React from "react";
import { connect } from "react-redux";
import { RunOnceDialog } from "../../processList/components/dialogs/RunOnceDialog";
import { ITriggerParameter } from "../../processList/model/Process";
import { IRunOnceProcessModel } from "../../processList/model/RunOnceDialogState";
import { AgentGroup, defaultAgentGroupName } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";
import { DispatchType, Utilities } from "../../shared/utilities";
import { closeRunOnceDialog, savingProcess } from "../actions/SaveProcess";
import { ParameterEditorValue } from "../model/ParameterEditorValue";
import { Process } from "../model/Process";
import { State } from "../model/State";
import { requestAndRedirect } from "../shared/model/SaveChangesAndRun";

class RunOnceDialogWrapper extends React.Component<RunDialogProps, RunDialogState> {
    constructor(props: RunDialogProps) {
        super(props)
        const triggerData: { [key: string]: string } = {};
        const parameters: ITriggerParameter[] = [];
        props.process.manualTrigger.forEach((x) => {
            triggerData[x.name] = x.defaultValue
            parameters.push({ name: x.name, isSecret: x.isSecret, description: x.description, nonStringifiedDefaultValue: x.nonStringifiedDefaultValue })
        });
        this.state = {
            runOnceProcessModel: [{ id: props.process.id, triggerData: triggerData, processName: props.process.name, parameters: parameters }]
        }
    }

    public handleRunOnce = () => {
        this.props.requestAndRedirect(this.props.agentGroup?.environment, this.props.agentGroup?.name, this.props.process.id, this.state.runOnceProcessModel[0].triggerData);
        this.props.closeRunOnceDialog();
    }

    render() {
        return (
            <RunOnceDialog
                closeRunOnceDialog={this.props.closeRunOnceDialog}
                onInputchange={this.handleInputChange}
                runOnceProcessModel={this.state.runOnceProcessModel}
                showRunOnceDialog={true}
                agentGroupName={this.props.agentGroup?.name}
                onRunOnce={this.handleRunOnce}
            />
        )
    }
    private handleInputChange = (id: number, key: string, value: string) => {
        const stateCopy = Object.assign({}, this.state);
        stateCopy.runOnceProcessModel[0].triggerData[key] = value;
        this.setState(stateCopy);
    }
}

interface RunDialogState {
    runOnceProcessModel: IRunOnceProcessModel[];
}

interface RunDialogOwnProps {

}

interface RunDialogStateProps {
    process: Process;
    agentGroup: AgentGroup | undefined;
}

interface RunDialogDispatchProps {
    closeRunOnceDialog: () => void;
    requestAndRedirect: (environment: string | undefined, name: string | undefined, id: number, triggerData: HashMap<string | ParameterEditorValue | undefined>) => void;
}

type RunDialogProps = RunDialogOwnProps & RunDialogStateProps & RunDialogDispatchProps;

const mapStateToProps = (state: State): RunDialogStateProps => {
    return {
        agentGroup: state.agentGroups.find(x => x.name == defaultAgentGroupName),
        process: state.process
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: RunDialogOwnProps): RunDialogDispatchProps => {
    return {
        closeRunOnceDialog: () => dispatch(closeRunOnceDialog()),
        requestAndRedirect: (environment: string, name: string, id: number, triggerData: HashMap<string>) => dispatch(requestAndRedirect(environment, name, id, triggerData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RunOnceDialogWrapper);
